<template>
  <nav class="navbar navbar-expand-lg c-bg">
    <div class="container-fluid">
      <a class="navbar-brand" href="#">
        <router-link to="/" class="navbar-brand mx-2 logotipo">
          <Logo></Logo>
        </router-link>
      </a>
      <!-- <ThemeButton /> -->
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup"
        aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
        <div class="navbar-nav">
          <a class="nav-link">
            <button class="btn nav-link" v-if="getIsAuthenticated" @click="logout">
              <span class="c-color">Cerrar Sesión</span>
            </button>
          </a>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import { LOGIN_ROUTE_PATH } from './../constants/routes_names.js'
import ThemeButton from './ThemeButton.vue'
import Logo from './Logo'

export default {
  components: {
    ThemeButton,
    Logo
  },
  computed: {
    ...mapGetters({ 'getIsAuthenticated' : 'user/getIsAuthenticated' }),
  },
  methods: {
    async logout() {
      await this.$store.dispatch('auth/logout')
      // this.$router.push({ name: 'ingreso' })
    }
  }
}
</script>

